import { useState } from 'react'
import { makeStyles } from '@mui/styles'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { driverLogin, searchDriver } from '../actions/t4aActions'
import { showAlertSnackbar } from '../reducers/sliceReducer'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import FullscreenLoading from '../components/FullscreenLoading'

const useStyles = makeStyles(theme => ({
  loginContainer: {
    width: 285,
    marginTop: 84,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  loginTitle: {
    width: 300,
    color: '#101820',
    fontSize: 17,
    fontWeight: 'bold',
    letterSpacing: 0
  },
  loginParam: {
    height: 24,
    color: '#636463',
    fontSize: 14,
    letterSpacing: 0
  },
  loginInput: {
    height: 48,
    width: 285
  },
  errorMessage: {
    color: '#E91F1F',
    fontSize: 16,
    letterSpacing: 0
  }
}))

function T4ALogin() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [loginFail, setLoginFail] = useState(false)

  function handleLogin() {
    setLoading(true)
    dispatch(driverLogin(username, password))
      .then(res => {
        setLoading(false)
        window.localStorage.setItem('driver_id', res.driver_id)
        dispatch(searchDriver(res.driver_id)).then(res => {
          if (res === null) {
            dispatch(
              showAlertSnackbar({
                message: 'Could not find t4-A info',
                type: 'error'
              })
            )
            setLoginFail(true)
          } else {
            history.push('/t4a-info')
          }
        })
      })
      .catch(error => {
        setLoading(false)
        setLoginFail(true)
      })
  }

  return (
    <div className={classes.loginContainer}>
      <img
        src='/images/group-copy.svg'
        alt=''
        style={{
          height: 42,
          width: 178,
          marginBottom: 34
        }}
      />
      <div className={classes.loginTitle}>Sign in / Ouvrir une session</div>
      <div className={classes.loginParam} style={{ marginTop: 33 }}>
        Mobile number / Numéro de portable
      </div>
      <TextField
        variant='standard'
        className={classes.loginInput}
        autoComplete={'false'}
        onChange={e => setUsername(e.target.value)}
      />
      <div className={classes.loginParam} style={{ marginTop: 29 }}>
        Social Insurance Number / Numéro d’assurance sociale
      </div>
      <TextField
        variant='standard'
        className={classes.loginInput}
        autoComplete={'false'}
        onChange={e => setPassword(e.target.value)}
        style={{ marginTop: 20 }}
      />
      <div className={classes.errorMessage} hidden={!loginFail}>
        Invalid login information. Please check details and try again.
      </div>
      <div
        style={{
          textAlign: 'center'
        }}>
        <Button
          sx={{
            width: 251,
            height: 40,
            color: 'white',
            backgroundColor: '#F68D2E !important',
            borderRadius: '20px',
            marginTop: '50px'
          }}
          onClick={handleLogin}
          disabled={loading}
          fullWidth>
          Sign in / Ouvrir une session
        </Button>
      </div>
      <FullscreenLoading open={loading} />
    </div>
  )
}

export default T4ALogin
